.updated {
  display: flex;
  justify-content: flex-end;
}